// @flow

const easeOutQuad = (x, t, b, c, d) =>
  -c * (t /= d) * (t - 2) + b;

const getScrollTop = () =>
  !!document.documentElement
    ? document.documentElement.scrollTop
    : !!document.body
      ? document.body.scrollTop
      : 0;

const setScrollTop = position => {
  if (!!document.documentElement && !!document.body) {
    document.documentElement.scrollTop = document.body.scrollTop = position;
  }
};

const getOffsetTop = element =>
  element.getBoundingClientRect().top + getScrollTop();

export default (id: ?string) => {
  const element = !!id ? document.getElementById(id) : document.body;
  if (!element) {
    return;
  }
  const start = getScrollTop();
  const to = getOffsetTop(element);
  const change = to - start;

  const animateFn = (elapsedTime = 0) => {
    const increment = 20;
    const elapsed = elapsedTime + increment;
    const position = easeOutQuad(null, elapsed, start, change, 400);
    setScrollTop(position);
    if (elapsed < 400) {
      setTimeout(() => {
        animateFn(elapsed);
      }, increment);
    }
  };

  animateFn();
};



// WEBPACK FOOTER //
// ./src/helpers/scrollHelper.js